module.exports = __webpack_public_path__ + "00_cheek.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/00_cheek.png
// module id = ToT5
// module chunks = 0